import { CgSpinner } from "react-icons/cg";

function LoadingSpinner({ className, ...rest }) {
  return <CgSpinner className={`animate-spin ${className || ""}`} {...rest} />;
}

export default LoadingSpinner;
